export var makeSelectors = function (storageName) {
    var selectors = {};
    return selectors;
};
